import API from '../../api/gpsdevices'

const store = {
  namespaced: true,
  state: () => ({
    items: [],
    item: {}
  }),
  mutations: {
    set(state, items) {
      state.items = items
    },
    show(state, item) {
      state.item = item
    }
  },
  actions: {
    async fetch(context) {
      const items = await API.list()
      context.commit('set', items)
    },
    async show(context, id) {
      const item = await API.show(id)
      context.commit('show', item)
    },
    async edit(context, { id, data }) {
      const item = await API.edit(id, data)
      context.commit('show', item)
    },
    async create(context, data) {
      const device = await API.create(data)
      context.commit('show', device)
    },
    async delete(context, id) {
      await API.delete(id)
      context.commit('show', {})
    }
  },
  getters: {
    items: state => {
      return state.items
    },
    item: state => {
      return state.item
    }
  }
}

export default store